export type PayrollConceptKind = 'salary' | 'benefit' | 'expense' | 'deduction';

export interface PayrollConcept {
  id: number;
  name: string;
  slug: string;
  kind?: PayrollConceptKind;
  is_available_for_base_salary_to_plus_bisual?: boolean;
  affects_irpf?: boolean;
  affects_ss?: boolean;
  counts_in_total_accrued?: boolean;
  is_system?: boolean;
}

export const PAYROLL_CONCEPT_SLUG = {
  BASE_SALARY: 'base-salary',
  SENIORITY_BONUS: 'seniority-bonus',
  FUEL_MILEAGE: 'fuel-mileage',
  EXTRA_HOURS: 'extra-hours',
  FLEXIBLE_REMUNERATION: 'flexible-remuneration',
  ADDITIONAL_SALARY: 'additional-salary',
} as const;

export const PAYROLL_CONCEPT_KIND = {
  SALARY: 'salary',
  BENEFIT: 'benefit',
  EXPENSE: 'expense',
  DEDUCTION: 'deduction',
} as const satisfies Record<string, PayrollConceptKind>;
